import styles from "../../../../styles/Components/new-insight/signals-section/signals-table/AssetCell.module.css";
import { useSelector } from "react-redux";
import AssetDisplay from "../../../../ui/AssetDisplay";
import useServiceStatus from "../../../../hooks/useServiceStatus";
import { getSignalTypePercentages } from "../../../../utility/helper";
import React from "react";
import { liveSuggestionFor } from "../../../../redux/live-suggestion/liveSuggestionSlice";

function AssetCell({ coin }) {
  const {
    liveSuggestion: { suggestions, liveTimeframe },
    newInsightState: { signalData, signalTableColumns },
  } = useSelector((state) => state);

  const { isActive } = useServiceStatus("insight");

  const liveData = liveSuggestionFor(suggestions, coin, liveTimeframe);

  const percentages = getSignalTypePercentages(
    signalData.filter((s) => s.coin === coin),
    signalTableColumns,
    liveData,
  );

  const validPercentages =
    percentages.sell || percentages.hold || percentages.buy;

  return (
    <div className={styles.container}>
      <AssetDisplay asset={coin} />
      {isActive && validPercentages ? (
        <div className={styles.bar}>
          <div className={styles.verticalBar}>
            <div
              style={{
                height: `${percentages.sell}%`,
                backgroundColor: "#EF4B4B",
              }}
              className={styles.barSegment}
            ></div>
            <div
              style={{
                height: `${percentages.hold}%`,
                backgroundColor: "#82A0D8",
              }}
              className={styles.barSegment}
            ></div>
            <div
              style={{
                height: `${percentages.buy}%`,
                backgroundColor: "#70AF85",
              }}
              className={styles.barSegment}
            ></div>
          </div>
          <div className={styles.bullets}>
            {percentages.sell ? (
              <span style={{ color: "#EF4B4B" }}>
                {/*<FaCircle size={10} />*/}
                {percentages.sell.toFixed(0)}%
              </span>
            ) : null}
            {percentages.hold ? (
              <span style={{ color: "#82A0D8" }}>
                {/*<FaCircle size={10} />*/}
                {percentages.hold.toFixed(0)}%
              </span>
            ) : null}
            {percentages.buy ? (
              <span style={{ color: "#70AF85" }}>
                {/*<FaCircle size={10} />*/}
                {percentages.buy.toFixed(0)}%
              </span>
            ) : null}
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default AssetCell;
